import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface ISaveJobData {
  id: string;
  name: string;
  job_code: string;
  description: string;
  street: string;
  users: Array<number>;
  requireGeofence: number;
  rate: number;
  track_mileage: number;
  radius: number;
  contactRequired: number;
  contact_name: string;
  contact_phone: string;
  contact_mobile: string;
  contact_email: string;
  landmark: string;
  state: string;
  city: string;
  zip_code: string;
  country: string;
  on_arrival: string;
  on_departure: string;
  latitude: number | null;
  all_users: number;
  longitude: number | null;
  geofenceMembers:
    | Array<{ id: number; firstName: string; lastName: string; employee_image: null | string }>
    | Array<any>;
  custom_geofence?: boolean;
  geofence_coordinates?: Array<any>;
  custom_fields?: any;
}

const saveJob = ({ id, ...postData }: ISaveJobData) => {
  if (id) {
    const newEndpoints = endpoints.job.jobsById.replace('{id}', id);
    return http().put(newEndpoints, postData);
  } else {
    return http().post(endpoints.job.base, postData);
  }
};

export function useSaveJob() {
  return useMutation({ mutationFn: saveJob });
}
